import type { EnumUnion } from '@dresscode-frontend/utility-types';
import type { GetPlaceAdministratorListItem } from '@/routes/_staff/places/-api';
type RoleColumn = Pick<GetPlaceAdministratorListItem, 'placeRoleId' | 'placeRoleLabel'>;
type PersonColumn = GetPlaceAdministratorListItem['administrators'][number];
export const PlaceAdministratorTableColumns = {
  ROLE: 'ROLE',
  IS_PRIMARY: 'IS_PRIMARY',
  PERSON: 'PERSON',
  ACTIONS: 'ACTIONS'
} as const;
export type PlaceAdministratorTableColumns = EnumUnion<typeof PlaceAdministratorTableColumns>;
type ActionsColumn = RoleColumn & PersonColumn & {
  placeId: string;
  canUnassign: boolean;
  canAssignPrimary: boolean;
};
export type PlaceAdministratorTableRow = {
  [PlaceAdministratorTableColumns.ROLE]: RoleColumn;
  [PlaceAdministratorTableColumns.IS_PRIMARY]: boolean;
  [PlaceAdministratorTableColumns.PERSON]: PersonColumn;
  [PlaceAdministratorTableColumns.ACTIONS]: ActionsColumn;
};
export const convertPlaceAdministratorItemToTableRow = (placeId: string, item: GetPlaceAdministratorListItem): PlaceAdministratorTableRow[] => {
  return item.administrators.map((administrator, index) => ({
    [PlaceAdministratorTableColumns.ROLE]: {
      placeRoleId: item.placeRoleId,
      placeRoleLabel: index === 0 ? item.placeRoleLabel : ''
    },
    [PlaceAdministratorTableColumns.IS_PRIMARY]: administrator.isPrimary,
    [PlaceAdministratorTableColumns.PERSON]: {
      ...administrator,
      id: administrator.personId
    },
    [PlaceAdministratorTableColumns.ACTIONS]: {
      ...item,
      ...administrator,
      placeId,
      canUnassign: true,
      canAssignPrimary: !administrator.isPrimary
    }
  }));
};